export enum StakingDate {
  THIRTY = 30,
  NINETY = 90,
  ONE_HUNDRED_EIGHTY = 180,
  THREE_HUNDRED_SIXTY_FIVE = 365,
}
